module.exports = __webpack_public_path__ + "static/media/CostSaving.ceb836b1.svg";